"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TextField = _interopRequireDefault(require("@eig-builder/core-ui/TextField"));

var _fieldWrapper = _interopRequireDefault(require("../field-wrapper"));

var _InputAdornment = _interopRequireDefault(require("@eig-builder/core-ui/InputAdornment"));

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _keys = _interopRequireDefault(require("lodash/keys"));

var _pick = _interopRequireDefault(require("lodash/pick"));

var _startCase = _interopRequireDefault(require("lodash/startCase"));

var _get = _interopRequireDefault(require("lodash/get"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _propertyEditorInternalContext = _interopRequireDefault(require("./../../contexts/property-editor-internal-context"));

var _withRegisterFieldId = _interopRequireDefault(require("./../../compositions/with-register-field-id"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var String = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(String, _PureComponent);

  var _super = _createSuper(String);

  function String(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, String);
    _this = _super.call(this, props);
    _this.state = {
      autoFill: undefined
    };

    _this.handleChange = function (event) {
      var _event$target, _event$target$value;

      if (_this.props.preventInputOnMaxCharacterCount && (event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : (_event$target$value = _event$target.value) === null || _event$target$value === void 0 ? void 0 : _event$target$value.length) > _this.excerptMaxLength) {
        var value = event.target.value.substring(0, _this.excerptMaxLength);

        _this.context.onChange(_this.props.fieldId, value);

        event.target.value = value;

        _this.props.onChange(event, _this.props.validationError);

        return;
      }

      _this.context.onChange(_this.props.fieldId, event.target.value);

      _this.props.onChange(event, _this.props.validationError);
    };

    _this.handleOnKeyDown = function (event) {
      _this.context.onKeyDown(_this.props.fieldId, event);
    };

    _this.handleBlur = function (event) {
      _this.context.onBlur(_this.props.fieldId);

      if (_this.props.convertValueOnBlur) {
        _this.props.convertValueOnBlur(event.target.value);
      }
    };

    _this.inputRef = _react["default"].createRef();
    _this.excerptMaxLengthValidator = (0, _isNil["default"])(props.validators) !== true && _this.props.validators.find(function (validator) {
      return validator.type.toLowerCase() === 'maxlength';
    });
    _this.excerptMaxLength = _this.excerptMaxLengthValidator ? _this.excerptMaxLengthValidator.value : 0;
    return _this;
  }

  (0, _createClass2["default"])(String, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      /*
      https://stackoverflow.com/questions/11708092/detecting-browser-autofill/41530164#41530164
      Handle chrome autofill. The autofill value + the label are shown on top of each other.
      Nasty fix: Listen to animation start based on a css class to fill the shrink property of the input label
      */
      this.inputRef.current && this.inputRef.current.addEventListener && this.inputRef.current.addEventListener('animationstart', function (e) {
        switch (e.animationName) {
          case 'fill-colors-of-autofill-input':
            return _this2.onAutoFillStart();

          case 'onAutoFillCancel':
            return _this2.onAutoFillCancel();
        }
      });
    }
  }, {
    key: "onAutoFillStart",
    value: function onAutoFillStart() {
      this.setState({
        autoFill: true
      });
    }
  }, {
    key: "onAutoFillCancel",
    value: function onAutoFillCancel() {
      this.setState({
        autoFill: undefined
      });
    }
  }, {
    key: "getInputProps",
    value: function getInputProps() {
      var inputProps = {};

      if ((0, _keys["default"])(this.props.InputProps).length) {
        return this.props.InputProps;
      }

      if (this.props.prefix) {
        inputProps.startAdornment = /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
          position: "start"
        }, this.props.prefix);
      }

      if (this.props.suffix) {
        inputProps.endAdornment = /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
          position: "end"
        }, this.props.suffix);
      }

      if (this.props.characterCount && this.excerptMaxLengthValidator) {
        inputProps.endAdornment = /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
          position: "end"
        }, this.props.value ? /*#__PURE__*/_react["default"].createElement(_FormHelperText["default"], {
          style: {
            margin: 0
          }
        }, this.props.value.length, "/", this.excerptMaxLength) : null);
      }

      if ((0, _keys["default"])(inputProps).length) {
        return inputProps;
      }

      return undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var fieldWrapperProps = (0, _pick["default"])(this.props, ['children', 'styleSettings', 'readOnly', 'type', 'data', 'noCol12', 'className']);
      var value = this.props.startCase ? (0, _startCase["default"])(this.props.value) : this.props.value;
      var shrinkProps = this.state.autoFill ? {
        shrink: true
      } : {};

      var inputPropsClone = _objectSpread(_objectSpread({}, this.props.inputProps), shrinkProps);

      var InputLabelProps = (0, _get["default"])(this.props, 'InputLabelProps', {});
      return /*#__PURE__*/_react["default"].createElement(_fieldWrapper["default"], fieldWrapperProps, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        inputRef: this.inputRef,
        onBlur: this.handleBlur,
        error: !!this.props.validationError,
        helperText: this.props.validationError || this.props.helperText,
        placeholder: this.props.hint,
        fullWidth: true,
        key: this.props.name,
        id: this.props.fieldId,
        name: this.props.fieldId,
        required: this.props.required,
        label: !this.props.hintInsteadOfLabel ? this.props.label : null,
        type: this.props.overrideType ? this.props.overrideType : this.props.type,
        disabled: this.props.readOnly,
        readOnly: this.props.readOnly,
        rows: this.props.rows,
        rowsMax: this.props.rowsMax,
        multiline: this.props.multiLine,
        onChange: this.handleChange,
        onKeyDown: this.handleOnKeyDown,
        autoComplete: this.props.wantAutoFill ? this.props.name : 'off',
        InputProps: this.getInputProps(),
        FormHelperTextProps: this.props.FormHelperTextProps,
        InputLabelProps: _objectSpread({
          shrink: this.state.autoFill
        }, InputLabelProps),
        variant: this.props.variant,
        value: value || '',
        autoFocus: this.props.autoFocus,
        inputProps: inputPropsClone,
        dataElementLocation: this.context.dataElementLocation,
        dataElementLabel: "".concat(this.context.dataElementLabelPrefix, "_").concat(this.props.name),
        dataElementId: "".concat(this.context.dataElementIdPrefix, "_").concat(this.props.name)
      }));
    }
  }]);
  return String;
}(_react.PureComponent);

String.contextType = _propertyEditorInternalContext["default"];
String.propTypes = {
  name: _propTypes["default"].string.isRequired,
  required: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  readOnly: _propTypes["default"].bool,
  rows: _propTypes["default"].number,
  rowsMax: _propTypes["default"].number,
  multiLine: _propTypes["default"].bool,
  wantAutoFill: _propTypes["default"].bool,
  characterCount: _propTypes["default"].bool,
  suffix: _propTypes["default"].string,
  prefix: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['standard', 'outlined', 'filled']),
  InputProps: _propTypes["default"].object,
  inputProps: _propTypes["default"].object,
  autoFocus: _propTypes["default"].bool,
  overrideType: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  FormHelperTextProps: _propTypes["default"].object,
  // styleSettings: PropTypes.object,
  // hintStyle: PropTypes.object,
  // helpImage: PropTypes.string,
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].node]),
  // heapIgnore: PropTypes.bool,
  // labelFixed: PropTypes.bool,
  // validateInstantly: PropTypes.bool,
  // BaseControl Should be a HOC, for now copy the required props
  fieldId: _propTypes["default"].string,
  value: _propTypes["default"].any,
  validators: _propTypes["default"].array,
  validationError: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element, _propTypes["default"].node]),
  hintInsteadOfLabel: _propTypes["default"].bool,
  startCase: _propTypes["default"].bool,
  convertValueOnBlur: _propTypes["default"].func,
  preventInputOnMaxCharacterCount: _propTypes["default"].bool,
  label: function label(props, propName, componentName) {
    if (!props.label && !props.hint) {
      return new Error("Both 'label' and 'hint' were not specified in '".concat(componentName, "'. The usage of either 'label' or 'hint' is required."));
    }
  },
  hint: function hint(props, propName, componentName) {
    if (!props.label && !props.hint) {
      return new Error("Both 'label' and 'hint' were not specified in '".concat(componentName, "'. The usage of either 'label' or 'hint' is required."));
    }

    if (props.hint && typeof props.hint !== 'string') {
      return new Error("The proptype 'hint' should be of type 'string' in ".concat(componentName));
    }
  }
};
String.defaultProps = {
  wantAutoFill: true,
  startCase: false,
  onChange: function onChange() {}
};

var _default = (0, _withRegisterFieldId["default"])(String);

exports["default"] = _default;